import * as Types from '../../../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type GetAllAttendanceReportsQueryVariables = Types.Exact<{
  projectId?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type GetAllAttendanceReportsQuery = { __typename?: 'HyperionSchemaQuery', projectGlobal?: { __typename?: 'Project', attendanceReportsStopParentIsNull?: { __typename?: 'AttendanceReportConnection', edges?: Array<{ __typename?: 'AttendanceReportEdge', node?: { __typename?: 'AttendanceReport', id: string, freeUserId?: number | null, parentId?: number | null, companyOrgNr?: string | null, startTime?: string | null, startOrStopTime?: string | null, startOrStop?: string | null, comment?: string | null, commentAboutUpdate?: string | null, isCanceled_PreAttendanceReportTypeHyperion?: string | null, mode?: string | null, correctionType?: number | null, editsCached_PreAttendanceReportTypeHyperion?: { __typename?: 'AttendanceReportConnection', totalCount: number, edges?: Array<{ __typename?: 'AttendanceReportEdge', node?: { __typename?: 'AttendanceReport', id: string, freeUserId?: number | null, parentId?: number | null, companyOrgNr?: string | null, startTime?: string | null, startOrStopTime?: string | null, startOrStop?: string | null, comment?: string | null, commentAboutUpdate?: string | null, isCanceled_PreAttendanceReportTypeHyperion?: string | null, mode?: string | null, correctionType?: number | null, realUser_PreAttendanceReportTypeHyperion?: { __typename?: 'realUser', id: string, firstName?: string | null, lastName?: string | null, personalNumber?: string | null } | null } | null } | null> | null } | null, start?: { __typename?: 'AttendanceReport', id: string, freeUserId?: number | null, parentId?: number | null, companyOrgNr?: string | null, startTime?: string | null, startOrStopTime?: string | null, startOrStop?: string | null, comment?: string | null, commentAboutUpdate?: string | null, isCanceled_PreAttendanceReportTypeHyperion?: string | null, mode?: string | null, correctionType?: number | null, editsCached_PreAttendanceReportTypeHyperion?: { __typename?: 'AttendanceReportConnection', totalCount: number, edges?: Array<{ __typename?: 'AttendanceReportEdge', node?: { __typename?: 'AttendanceReport', id: string, freeUserId?: number | null, parentId?: number | null, companyOrgNr?: string | null, startTime?: string | null, startOrStopTime?: string | null, startOrStop?: string | null, comment?: string | null, commentAboutUpdate?: string | null, isCanceled_PreAttendanceReportTypeHyperion?: string | null, mode?: string | null, correctionType?: number | null, realUser_PreAttendanceReportTypeHyperion?: { __typename?: 'realUser', id: string, firstName?: string | null, lastName?: string | null, personalNumber?: string | null } | null } | null } | null> | null } | null, realUser_PreAttendanceReportTypeHyperion?: { __typename?: 'realUser', id: string, firstName?: string | null, lastName?: string | null, personalNumber?: string | null } | null } | null, realUser_PreAttendanceReportTypeHyperion?: { __typename?: 'realUser', id: string, firstName?: string | null, lastName?: string | null, personalNumber?: string | null } | null } | null } | null> | null } | null } | null };

export type GetHoursQueryVariables = Types.Exact<{
  projectId?: Types.InputMaybe<Types.Scalars['Int']>;
  orgNr?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type GetHoursQuery = { __typename?: 'HyperionSchemaQuery', project?: { __typename?: 'Project', attendanceReportsMeta_PreProjectTypeHyperion?: { __typename?: 'attendanceReportsMeta_PreProjectTypeHyperion_fields', sumHours?: string | null } | null } | null };

export type AttendanceReportFragment = { __typename?: 'AttendanceReport', id: string, freeUserId?: number | null, parentId?: number | null, companyOrgNr?: string | null, startTime?: string | null, startOrStopTime?: string | null, startOrStop?: string | null, comment?: string | null, commentAboutUpdate?: string | null, isCanceled_PreAttendanceReportTypeHyperion?: string | null, mode?: string | null, correctionType?: number | null, editsCached_PreAttendanceReportTypeHyperion?: { __typename?: 'AttendanceReportConnection', totalCount: number, edges?: Array<{ __typename?: 'AttendanceReportEdge', node?: { __typename?: 'AttendanceReport', id: string, freeUserId?: number | null, parentId?: number | null, companyOrgNr?: string | null, startTime?: string | null, startOrStopTime?: string | null, startOrStop?: string | null, comment?: string | null, commentAboutUpdate?: string | null, isCanceled_PreAttendanceReportTypeHyperion?: string | null, mode?: string | null, correctionType?: number | null, realUser_PreAttendanceReportTypeHyperion?: { __typename?: 'realUser', id: string, firstName?: string | null, lastName?: string | null, personalNumber?: string | null } | null } | null } | null> | null } | null, start?: { __typename?: 'AttendanceReport', id: string, freeUserId?: number | null, parentId?: number | null, companyOrgNr?: string | null, startTime?: string | null, startOrStopTime?: string | null, startOrStop?: string | null, comment?: string | null, commentAboutUpdate?: string | null, isCanceled_PreAttendanceReportTypeHyperion?: string | null, mode?: string | null, correctionType?: number | null, editsCached_PreAttendanceReportTypeHyperion?: { __typename?: 'AttendanceReportConnection', totalCount: number, edges?: Array<{ __typename?: 'AttendanceReportEdge', node?: { __typename?: 'AttendanceReport', id: string, freeUserId?: number | null, parentId?: number | null, companyOrgNr?: string | null, startTime?: string | null, startOrStopTime?: string | null, startOrStop?: string | null, comment?: string | null, commentAboutUpdate?: string | null, isCanceled_PreAttendanceReportTypeHyperion?: string | null, mode?: string | null, correctionType?: number | null, realUser_PreAttendanceReportTypeHyperion?: { __typename?: 'realUser', id: string, firstName?: string | null, lastName?: string | null, personalNumber?: string | null } | null } | null } | null> | null } | null, realUser_PreAttendanceReportTypeHyperion?: { __typename?: 'realUser', id: string, firstName?: string | null, lastName?: string | null, personalNumber?: string | null } | null } | null, realUser_PreAttendanceReportTypeHyperion?: { __typename?: 'realUser', id: string, firstName?: string | null, lastName?: string | null, personalNumber?: string | null } | null };

export type BaseAttendanceReportFragment = { __typename?: 'AttendanceReport', id: string, freeUserId?: number | null, parentId?: number | null, companyOrgNr?: string | null, startTime?: string | null, startOrStopTime?: string | null, startOrStop?: string | null, comment?: string | null, commentAboutUpdate?: string | null, isCanceled_PreAttendanceReportTypeHyperion?: string | null, mode?: string | null, correctionType?: number | null, realUser_PreAttendanceReportTypeHyperion?: { __typename?: 'realUser', id: string, firstName?: string | null, lastName?: string | null, personalNumber?: string | null } | null };

export type CompanyDataQueryVariables = Types.Exact<{
  projectId?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type CompanyDataQuery = { __typename?: 'HyperionSchemaQuery', company?: { __typename?: 'Company', name?: string | null, orgNr?: string | null } | null, project?: { __typename?: 'Project', constructionSiteNumber?: string | null, allowSubcontractorToAdSubcontractors?: number | null } | null };

export type CompanyFragment = { __typename?: 'Company', name?: string | null, orgNr?: string | null };

export type SubcontractorsQueryVariables = Types.Exact<{
  projectId?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type SubcontractorsQuery = { __typename?: 'HyperionSchemaQuery', project?: { __typename?: 'Project', subcontractorsRelations?: { __typename?: 'SubcontractorRelationToProjectConnection', edges?: Array<{ __typename?: 'SubcontractorRelationToProjectEdge', node?: { __typename?: 'SubcontractorRelationToProject', subcontractor?: { __typename?: 'Subcontractor', id: string, name?: string | null, orgNr?: string | null } | null } | null } | null> | null } | null } | null };

export type AllSubcontractorsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AllSubcontractorsQuery = { __typename?: 'HyperionSchemaQuery', company?: { __typename?: 'Company', subcontractors?: { __typename?: 'SubcontractorConnection', edges?: Array<{ __typename?: 'SubcontractorEdge', node?: { __typename?: 'Subcontractor', id: string, name?: string | null, orgNr?: string | null } | null } | null> | null } | null } | null };

export type SubcontractorFragment = { __typename?: 'Subcontractor', id: string, name?: string | null, orgNr?: string | null };

export type AddSubcontractorMutationVariables = Types.Exact<{
  projectId?: Types.InputMaybe<Types.Scalars['Int']>;
  subcontractorId?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type AddSubcontractorMutation = { __typename?: 'HyperionSchemaMutation', subcontractorRelationToProjectTypeHyperionMutation?: { __typename?: 'SubcontractorRelationToProject', subcontractor?: { __typename?: 'Subcontractor', id: string, email?: string | null, name?: string | null } | null, mutationDetails?: Array<{ __typename?: 'ModelErrorsTypeHyperionBase', argument?: string | null, errorsMsgs?: Array<string | null> | null, infoMsgs?: Array<string | null> | null, model?: string | null, modelErrorsMsgs?: Array<string | null> | null, modelSuccessMsgs?: Array<string | null> | null, modelWarningMsgs?: Array<string | null> | null, msg?: string | null, mutationSucceeded?: boolean | null, successMsgs?: Array<string | null> | null, warningMsgs?: Array<string | null> | null } | null> | null } | null };

export type CreateSubcontractorMutationVariables = Types.Exact<{
  name?: Types.InputMaybe<Types.Scalars['String']>;
  mail?: Types.InputMaybe<Types.Scalars['String']>;
  orgNr?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type CreateSubcontractorMutation = { __typename?: 'HyperionSchemaMutation', subcontractorTypeHyperionMutation?: { __typename?: 'Subcontractor', id: string, mutationDetails?: Array<{ __typename?: 'ModelErrorsTypeHyperionBase', argument?: string | null, errorsMsgs?: Array<string | null> | null, infoMsgs?: Array<string | null> | null, model?: string | null, modelErrorsMsgs?: Array<string | null> | null, modelSuccessMsgs?: Array<string | null> | null, modelWarningMsgs?: Array<string | null> | null, msg?: string | null, mutationSucceeded?: boolean | null, successMsgs?: Array<string | null> | null, warningMsgs?: Array<string | null> | null } | null> | null } | null };

export type MutationDetailsFragment = { __typename?: 'ModelErrorsTypeHyperionBase', argument?: string | null, errorsMsgs?: Array<string | null> | null, infoMsgs?: Array<string | null> | null, model?: string | null, modelErrorsMsgs?: Array<string | null> | null, modelSuccessMsgs?: Array<string | null> | null, modelWarningMsgs?: Array<string | null> | null, msg?: string | null, mutationSucceeded?: boolean | null, successMsgs?: Array<string | null> | null, warningMsgs?: Array<string | null> | null };

export type RemoveSubcontractorMutationVariables = Types.Exact<{
  id?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type RemoveSubcontractorMutation = { __typename?: 'HyperionSchemaMutation', subcontractorRelationToProjectTypeHyperionMutation?: { __typename?: 'SubcontractorRelationToProject', mutationDetails?: Array<{ __typename?: 'ModelErrorsTypeHyperionBase', argument?: string | null, errorsMsgs?: Array<string | null> | null, infoMsgs?: Array<string | null> | null, model?: string | null, modelErrorsMsgs?: Array<string | null> | null, modelSuccessMsgs?: Array<string | null> | null, modelWarningMsgs?: Array<string | null> | null, msg?: string | null, mutationSucceeded?: boolean | null, successMsgs?: Array<string | null> | null, warningMsgs?: Array<string | null> | null } | null> | null } | null };

export type SubcontractorsRelationsQueryVariables = Types.Exact<{
  projectId?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type SubcontractorsRelationsQuery = { __typename?: 'HyperionSchemaQuery', project?: { __typename?: 'Project', subcontractorsRelations?: { __typename?: 'SubcontractorRelationToProjectConnection', edges?: Array<{ __typename?: 'SubcontractorRelationToProjectEdge', node?: { __typename?: 'SubcontractorRelationToProject', id: string, subcontractorId?: number | null } | null } | null> | null } | null } | null };

export type AllowChangeMutationVariables = Types.Exact<{
  projectId?: Types.InputMaybe<Types.Scalars['Int']>;
  allow?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type AllowChangeMutation = { __typename?: 'HyperionSchemaMutation', projectTypeHyperionMutation?: { __typename?: 'Project', mutationDetails?: Array<{ __typename?: 'ModelErrorsTypeHyperionBase', argument?: string | null, errorsMsgs?: Array<string | null> | null, infoMsgs?: Array<string | null> | null, model?: string | null, modelErrorsMsgs?: Array<string | null> | null, modelSuccessMsgs?: Array<string | null> | null, modelWarningMsgs?: Array<string | null> | null, msg?: string | null, mutationSucceeded?: boolean | null, successMsgs?: Array<string | null> | null, warningMsgs?: Array<string | null> | null } | null> | null } | null };

export const BaseAttendanceReportFragmentDoc = gql`
    fragment baseAttendanceReport on AttendanceReport {
  id
  freeUserId
  parentId
  companyOrgNr
  startTime
  startOrStopTime
  startOrStop
  comment
  commentAboutUpdate
  isCanceled_PreAttendanceReportTypeHyperion
  realUser_PreAttendanceReportTypeHyperion {
    id
    firstName
    lastName
    personalNumber
  }
  mode
  correctionType
}
    `;
export const AttendanceReportFragmentDoc = gql`
    fragment attendanceReport on AttendanceReport {
  id
  ...baseAttendanceReport
  editsCached_PreAttendanceReportTypeHyperion {
    edges {
      node {
        ...baseAttendanceReport
      }
    }
    totalCount
  }
  start {
    ...baseAttendanceReport
    editsCached_PreAttendanceReportTypeHyperion {
      edges {
        node {
          ...baseAttendanceReport
        }
      }
      totalCount
    }
  }
}
    ${BaseAttendanceReportFragmentDoc}`;
export const CompanyFragmentDoc = gql`
    fragment company on Company {
  name
  orgNr
}
    `;
export const SubcontractorFragmentDoc = gql`
    fragment subcontractor on Subcontractor {
  id
  name
  orgNr
}
    `;
export const MutationDetailsFragmentDoc = gql`
    fragment MutationDetails on ModelErrorsTypeHyperionBase {
  argument
  errorsMsgs
  infoMsgs
  model
  modelErrorsMsgs
  modelSuccessMsgs
  modelWarningMsgs
  msg
  mutationSucceeded
  successMsgs
  warningMsgs
}
    `;
export const GetAllAttendanceReportsDocument = gql`
    query getAllAttendanceReports($projectId: Int) {
  projectGlobal(id: $projectId) {
    attendanceReportsStopParentIsNull {
      edges {
        node {
          ...attendanceReport
        }
      }
    }
  }
}
    ${AttendanceReportFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllAttendanceReportsGQL extends Apollo.Query<GetAllAttendanceReportsQuery, GetAllAttendanceReportsQueryVariables> {
    document = GetAllAttendanceReportsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetHoursDocument = gql`
    query getHours($projectId: Int, $orgNr: String) {
  project(id: $projectId) {
    attendanceReportsMeta_PreProjectTypeHyperion(orgNr: $orgNr) {
      sumHours
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetHoursGQL extends Apollo.Query<GetHoursQuery, GetHoursQueryVariables> {
    document = GetHoursDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CompanyDataDocument = gql`
    query companyData($projectId: Int) {
  company {
    ...company
  }
  project(id: $projectId) {
    constructionSiteNumber
    allowSubcontractorToAdSubcontractors
  }
}
    ${CompanyFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CompanyDataGQL extends Apollo.Query<CompanyDataQuery, CompanyDataQueryVariables> {
    document = CompanyDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SubcontractorsDocument = gql`
    query subcontractors($projectId: Int) {
  project(id: $projectId) {
    subcontractorsRelations {
      edges {
        node {
          subcontractor {
            ...subcontractor
          }
        }
      }
    }
  }
}
    ${SubcontractorFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SubcontractorsGQL extends Apollo.Query<SubcontractorsQuery, SubcontractorsQueryVariables> {
    document = SubcontractorsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AllSubcontractorsDocument = gql`
    query allSubcontractors {
  company {
    subcontractors {
      edges {
        node {
          ...subcontractor
        }
      }
    }
  }
}
    ${SubcontractorFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AllSubcontractorsGQL extends Apollo.Query<AllSubcontractorsQuery, AllSubcontractorsQueryVariables> {
    document = AllSubcontractorsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddSubcontractorDocument = gql`
    mutation addSubcontractor($projectId: Int, $subcontractorId: Int) {
  subcontractorRelationToProjectTypeHyperionMutation(
    createSubcontractorRelationToProject: {projectId: $projectId, subcontractorId: $subcontractorId, attendance: 1}
  ) {
    subcontractor {
      id
      email
      name
    }
    mutationDetails {
      ...MutationDetails
    }
  }
}
    ${MutationDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AddSubcontractorGQL extends Apollo.Mutation<AddSubcontractorMutation, AddSubcontractorMutationVariables> {
    document = AddSubcontractorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateSubcontractorDocument = gql`
    mutation createSubcontractor($name: String, $mail: String, $orgNr: String) {
  subcontractorTypeHyperionMutation(
    createSubcontractor: {name: $name, email: $mail, orgNr: $orgNr}
  ) {
    id
    mutationDetails {
      ...MutationDetails
    }
  }
}
    ${MutationDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateSubcontractorGQL extends Apollo.Mutation<CreateSubcontractorMutation, CreateSubcontractorMutationVariables> {
    document = CreateSubcontractorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveSubcontractorDocument = gql`
    mutation removeSubcontractor($id: Int) {
  subcontractorRelationToProjectTypeHyperionMutation(
    deleteSubcontractorRelationToProject: {id: $id}
  ) {
    mutationDetails {
      ...MutationDetails
    }
  }
}
    ${MutationDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveSubcontractorGQL extends Apollo.Mutation<RemoveSubcontractorMutation, RemoveSubcontractorMutationVariables> {
    document = RemoveSubcontractorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SubcontractorsRelationsDocument = gql`
    query subcontractorsRelations($projectId: Int) {
  project(id: $projectId) {
    subcontractorsRelations {
      edges {
        node {
          id
          subcontractorId
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SubcontractorsRelationsGQL extends Apollo.Query<SubcontractorsRelationsQuery, SubcontractorsRelationsQueryVariables> {
    document = SubcontractorsRelationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AllowChangeDocument = gql`
    mutation allowChange($projectId: Int, $allow: Int) {
  projectTypeHyperionMutation(
    updateProject: {id: $projectId, allowSubcontractorToAdSubcontractors: $allow}
  ) {
    mutationDetails {
      ...MutationDetails
    }
  }
}
    ${MutationDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AllowChangeGQL extends Apollo.Mutation<AllowChangeMutation, AllowChangeMutationVariables> {
    document = AllowChangeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }